import api from '../http/api'

// 自定义适配器类
class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader
    }

    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                var formData = new FormData()
                formData.append('file', file)
                api.area.upload(formData).then((res) => {
                    if (res.success) {
                        const result = {
                            default: res.data
                        }
                        resolve(result)
                    } else {
                        reject(res.message || '上传图片错误')
                    }
                })
            }))
    }
}

function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new MyUploadAdapter(loader)
    }
}

export default MyCustomUploadAdapterPlugin


// WEBPACK FOOTER //
// ./src/utils/uploadAdapter.js